<template>
    <input id="memoFont">
</template>

<script>
    export default {
        mounted() {
            var self = this
            $('#memoFont').fontselect().change(function() {
            var memoFont = $(this).val().replace(/\+/g, ' ');
                memoFont = memoFont.split(':');
                  self.$emit('get-font-memo', memoFont[0]);
        });
    }
}
</script>


// WEBPACK FOOTER //
// src/components/JQueryPluggins/FontMemo.vue